// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"3981":"block0","9735":"block12"}[chunkId] + "." + {"3981":"86f34f3b","9735":"3472217c"}[chunkId] + ".css";
};